{
    "CAIS-FDID-Quick-Search-Fields": [
        {
            "label": "Report Date", "columnname": "reportDate", "placeholder": "Report Date",
            "width": "", "datatype": "DateRange", "isLarge": false, "fieldtype": "maskfield", "mask": "9999-99-99", "slotchar": "yyyy-mm-dd"
        },
        {
            "label": "Finra Status", "columnname": "lastFinraStatus", "placeholder": "Finra Status",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Account Number", "columnname": "accountNumber", "placeholder": "Account Number",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Received FDID", "columnname": "receivedFDID", "placeholder": "Received FDID",
            "width": "", "datatype": "String", "isLarge": false, "isXLarge": true
        }
    ],
    "CAISFDIDCols": [
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "rsmsStatus",
            "datatype": "char",
            "mappingkey": "rsmsStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "Finra Status",
            "db_columnname": "lastFinraStatus",
            "datatype": "String",
            "mappingkey": "lastFinraStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Active",
            "db_columnname": "active",
            "datatype": "String",
            "mappingkey": "active",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "false",
            "ui_columnname": "Firm",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 3
        },
        {
            "display": "true",
            "ui_columnname": "FDID Action",
            "db_columnname": "action",
            "datatype": "String",
            "mappingkey": "action",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "ADD",
                    "value": "ADD"
                },
                {
                    "label": "UPDATE",
                    "value": "UPDATE"
                },
                {
                    "label": "REPLACE",
                    "value": "REPLACE"
                },
                {
                    "label": "DELETE",
                    "value": "DELETE"
                }
            ],
            "isrequired": true,
            "sortOrder": 4
        },
        {
            "display": "true",
            "ui_columnname": "Account Number",
            "db_columnname": "accountNumber",
            "datatype": "String",
            "mappingkey": "accountNumber",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "50",
            "isLargeFields": true,
            "hasAlternativeField": true,
            "alternativeFields": ["receivedFDID"],
            "sortOrder": 5
        },
        {
            "display": "true",
            "ui_columnname": "Received FDID",
            "db_columnname": "receivedFDID",
            "datatype": "String",
            "mappingkey": "receivedFDID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "40",
            "isLargeFields": true,
            "hasAlternativeField": true,
            "alternativeFields": ["accountNumber"],
            "sortOrder": 6
        },
        {
            "display": "true",
            "ui_columnname": "FDID Type",
            "db_columnname": "fdidType",
            "datatype": "String",
            "mappingkey": "fdidType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "ACCOUNT",
                    "value": "ACCOUNT"
                },
                {
                    "label": "RELATIONSHIP",
                    "value": "RELATIONSHIP"
                },
                {
                    "label": "ENTITYID",
                    "value": "ENTITYID"
                }
            ],
            "isrequired": true,
            "sortOrder": 9
        },
        {
            "display": "true",
            "ui_columnname": "Account Type",
            "db_columnname": "accountType",
            "datatype": "Array",
            "mappingkey": "accountType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": [],
            "dropdowntype": "multiselect",
            "dropdownvalue": [
                {
                    "label": "ADVISED",
                    "value": "ADVISED"
                },
                {
                    "label": "AVERAGE",
                    "value": "AVERAGE"
                },
                {
                    "label": "BROKERAGE",
                    "value": "BROKERAGE"
                },
                {
                    "label": "DVP/RVP",
                    "value": "DVP/RVP"
                },
                {
                    "label": "EDUCATION",
                    "value": "EDUCATION"
                },
                {
                    "label": "ENTITYID",
                    "value": "ENTITYID"
                },
                {
                    "label": "ERROR",
                    "value": "ERROR"
                },
                {
                    "label": "FIRM",
                    "value": "FIRM"
                },
                {
                    "label": "INSTITUTION",
                    "value": "INSTITUTION"
                },
                {
                    "label": "MARKET",
                    "value": "MARKET"
                },
                {
                    "label": "MARGIN",
                    "value": "MARGIN"
                },
                {
                    "label": "OPTION",
                    "value": "OPTION"
                },
                {
                    "label": "OTHER",
                    "value": "OTHER"
                },
                {
                    "label": "RELATIONSHIP",
                    "value": "RELATIONSHIP"
                },
                {
                    "label": "RETIREMENT",
                    "value": "RETIREMENT"
                },
                {
                    "label": "UGMA/UTMA",
                    "value": "UGMA/UTMA"
                }
            ],
            "isrequired": true,
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "Account Name",
            "db_columnname": "accountName",
            "datatype": "String",
            "mappingkey": "accountName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isLargeFields": true,
            "isrequired": false,
            "sortOrder": 7
        },
        {
            "display": "true",
            "ui_columnname": "FDID Date",
            "db_columnname": "fdidDate",
            "datatype": "Date",
            "mappingkey": "fdidDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "isrequired": true,
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "FDID End Date",
            "db_columnname": "fdidEndDate",
            "datatype": "Date",
            "mappingkey": "fdidEndDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "sortOrder": 14
        },
        {
            "display": "false",
            "ui_columnname": "FDID End Reason",
            "db_columnname": "fdidEndReason",
            "datatype": "String",
            "mappingkey": "fdidEndReason",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "CORRECTION",
                    "value": "CORRECTION"
                },
                {
                    "label": "ENDED",
                    "value": "ENDED"
                },
                {
                    "label": "REPLACED",
                    "value": "REPLACED"
                },
                {
                    "label": "OTHER",
                    "value": "OTHER"
                },
                {
                    "label": "TRANSFER",
                    "value": "TRANSFER"
                }
            ],
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1",
            "db_columnname": "addrLine1",
            "datatype": "String",
            "mappingkey": "addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2",
            "db_columnname": "addrLine2",
            "datatype": "String",
            "mappingkey": "addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 17
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3",
            "db_columnname": "addrLine3",
            "datatype": "String",
            "mappingkey": "addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 18
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4",
            "db_columnname": "addrLine4",
            "datatype": "String",
            "mappingkey": "addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 19
        },
        {
            "display": "true",
            "ui_columnname": "City",
            "db_columnname": "city",
            "datatype": "String",
            "mappingkey": "city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 20
        },
        {
            "display": "true",
            "ui_columnname": "Region Code",
            "db_columnname": "regionCode",
            "datatype": "String",
            "mappingkey": "regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 21
        },
        {
            "display": "true",
            "ui_columnname": "Country Code",
            "db_columnname": "countryCode",
            "datatype": "String",
            "mappingkey": "countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 22
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code",
            "db_columnname": "postalCode",
            "datatype": "String",
            "mappingkey": "postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 23
        },
        {
            "display": "true",
            "ui_columnname": "Firm DesignatedID",
            "db_columnname": "firmDesignatedID",
            "datatype": "String",
            "mappingkey": "firmDesignatedID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "40",
            "isLargeFields": true,
            "isrequired": false,
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "Fdid Record ID",
            "db_columnname": "id",
            "datatype": "Int",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "true",
            "ui_columnname": "DVP CustodianID",
            "db_columnname": "DVPCustodianID",
            "datatype": "String",
            "mappingkey": "DVPCustodianID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 11
        },
        {
            "display": "true",
            "ui_columnname": "AuthTraderList",
            "db_columnname": "authTraderList",
            "datatype": "String",
            "mappingkey": "authTraderList",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "isOptionalFields": true,
            "sortOrder": 41
        },
        {
            "display": "true",
            "ui_columnname": "Clearing BrokerID",
            "db_columnname": "clearingBrokerID",
            "datatype": "String",
            "mappingkey": "clearingBrokerID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 12
        },
        {
            "display": "true",
            "ui_columnname": "Branch Ofice CRD",
            "db_columnname": "branchOfficeCRD",
            "datatype": "String",
            "mappingkey": "branchOfficeCRD",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "Role",
            "db_columnname": "role",
            "datatype": "String",
            "mappingkey": "role",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "AUTH3RD",
                    "value": "AUTH3RD"
                },
                {
                    "label": "AUTHREP",
                    "value": "AUTHREP"
                },
                {
                    "label": "NTHOLDER",
                    "value": "NTHOLDER"
                },
                {
                    "label": "TRDHOLDER",
                    "value": "TRDHOLDER"
                }
            ],
            "isrequired": true,
            "sortOrder": 24
        },
        {
            "display": "true",
            "ui_columnname": "Role Start Date",
            "db_columnname": "roleStartDate",
            "datatype": "Date",
            "mappingkey": "roleStartDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "isrequired": true,
            "sortOrder": 24
        },
        {
            "display": "true",
            "ui_columnname": "Is Natural Person",
            "db_columnname": "isNaturalPerson",
            "datatype": "String",
            "mappingkey": "isNaturalPerson",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "Y",
                    "value": "Y"
                },
                {
                    "label": "N",
                    "value": "N"
                }
            ],
            "sortOrder": 38
        },
        {
            "display": "true",
            "ui_columnname": "Has Discretion",
            "db_columnname": "hasDiscretion",
            "datatype": "String",
            "mappingkey": "hasDiscretion",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "Y",
                    "value": "Y"
                },
                {
                    "label": "N",
                    "value": "N"
                }
            ],
            "sortOrder": 25
        },
        {
            "display": "true",
            "ui_columnname": "Customer Type",
            "db_columnname": "customerType",
            "datatype": "Array",
            "mappingkey": "customerType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": [],
            "dropdowntype": "multiselect",
            "dropdownvalue": [
                {
                    "label": "ACCREDITED",
                    "value": "ACCREDITED"
                },
                {
                    "label": "ADVISER",
                    "value": "ADVISER"
                },
                {
                    "label": "CP",
                    "value": "CP"
                },
                {
                    "label": "EMPLOYEE",
                    "value": "EMPLOYEE"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "NOTAPPLICABLE",
                    "value": "NOTAPPLICABLE"
                },
                {
                    "label": "OTHBKR",
                    "value": "OTHBKR"
                },
                {
                    "label": "TRUST",
                    "value": "TRUST"
                },
                {
                    "label": "BD",
                    "value": "BD"
                },
                {
                    "label": "RIC",
                    "value": "RIC"
                }
            ],
            "isrequired": true,
            "sortOrder": 23
        },
        {
            "display": "true",
            "ui_columnname": "Customer Record ID",
            "db_columnname": "customerRecordID",
            "datatype": "String",
            "mappingkey": "customerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 39
        },
        {
            "display": "true",
            "ui_columnname": "In Customer Record ID",
            "db_columnname": "inCustomerRecordID",
            "datatype": "String",
            "mappingkey": "inCustomerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Report Reason",
            "db_columnname": "reportReason",
            "datatype": "String",
            "mappingkey": "reportReason",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Init Finra Status",
            "db_columnname": "initFinraStatus",
            "datatype": "String",
            "mappingkey": "initFinraStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Init Finra Submission File Name",
            "db_columnname": "initFinraSubmissionFileName",
            "datatype": "String",
            "mappingkey": "initFinraSubmissionFileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Initial Finra Submission Date",
            "db_columnname": "initialFinraSubmissionDate",
            "datatype": "String",
            "mappingkey": "initialFinraSubmissionDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Initial Finra Feedback Date",
            "db_columnname": "initFinraFeedbackDateTime",
            "datatype": "String",
            "mappingkey": "initFinraFeedbackDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Last Finra Submission File Name",
            "db_columnname": "lastFinraSubmissionFileName",
            "datatype": "String",
            "mappingkey": "lastFinraSubmissionFileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Last Finra Submission Date",
            "db_columnname": "lastFinraSubmissionDate",
            "datatype": "String",
            "mappingkey": "lastFinraSubmissionDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Last Finra Feedback DateTime",
            "db_columnname": "lastFinraFeedbackDateTime",
            "datatype": "String",
            "mappingkey": "lastFinraFeedbackDateTime",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        },
        {
            "display": "false",
            "ui_columnname": "Register Rep CRD",
            "db_columnname": "registeredRepCRD",
            "datatype": "String",
            "mappingkey": "registeredRepCRD",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 13
        },
        {
            "display": "false",
            "ui_columnname": "Foreign TID Country",
            "db_columnname": "foreignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "foreignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 40
        },
        {
            "display": "false",
            "ui_columnname": "Rep By TID Type",
            "db_columnname": "replacedByTIDType",
            "datatype": "String",
            "mappingkey": "replacedByTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "sortOrder": 42
        },
        {
            "display": "false",
            "ui_columnname": "Rep by Foreign TID Type",
            "db_columnname": "replacingForeignTIDType",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 43
        },
        {
            "display": "false",
            "ui_columnname": "Replacing Foreign TID Country",
            "db_columnname": "replacingForeignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 43
        },
        {
            "display": "false",
            "ui_columnname": "Rep By TID Value",
            "db_columnname": "replacedByTID",
            "datatype": "String",
            "mappingkey": "replacedByTID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "64",
            "sortOrder": 44
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "updatedUser",
            "datatype": "String",
            "mappingkey": "updatedUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 47
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updatedDate",
            "datatype": "String",
            "mappingkey": "updatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 48
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 45
        },
        {
            "display": "true",
            "ui_columnname": "Created User",
            "db_columnname": "createdUser",
            "datatype": "String",
            "mappingkey": "createdUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 46
        },
        {
            "display": "true",
            "ui_columnname": "File ID",
            "db_columnname": "fileID",
            "datatype": "String",
            "mappingkey": "fileID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 40
        }
    ],
    "AddressesDataCols": [
      
        {
            "display": "true",
            "ui_columnname": "Address Line 1",
            "db_columnname": "addr_addrLine1",
            "datatype": "String",
            "mappingkey": "addr_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "maxlength": "40",
            "regexpressions": ["^([\\s+\\w-'/`~!#*$@_%+=.,^&(){}[]|;:\"<>?\\]){0,40}$"],
            "isOptionalFields": true
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2",
            "db_columnname": "addr_addrLine2",
            "datatype": "String",
            "mappingkey": "addr_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "40",
            "regexpressions": ["^([\\s+\\w-'/`~!#*$@_%+=.,^&(){}[]|;:\"<>?\\]){0,40}$"],
            "isOptionalFields": true
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3",
            "db_columnname": "addr_addrLine3",
            "datatype": "String",
            "mappingkey": "addr_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "40",
            "regexpressions": ["^([\\s+\\w-'/`~!#*$@_%+=.,^&(){}[]|;:\"<>?\\]){0,40}$"],
            "isOptionalFields": true
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4",
            "db_columnname": "addr_addrLine4",
            "datatype": "String",
            "mappingkey": "addr_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "40",
            "regexpressions": ["^([\\s+\\w-'/`~!#*$@_%+=.,^&(){}[]|;:\"<>?\\]){0,40}$"],
            "isOptionalFields": true
        },
        {
            "display": "true",
            "ui_columnname": "City",
            "db_columnname": "addr_city",
            "datatype": "String",
            "mappingkey": "addr_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "isOptionalFields": true
        },
        {
            "display": "true",
            "ui_columnname": "Region Code",
            "db_columnname": "addr_regionCode",
            "datatype": "String",
            "mappingkey": "addr_regionCode",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "isOptionalFields": true
        },
        {
            "display": "true",
            "ui_columnname": "Country Code",
            "db_columnname": "addr_countryCode",
            "datatype": "String",
            "mappingkey": "addr_countryCode",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "isrequired": false,
            "isOptionalFields": true
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code",
            "db_columnname": "addr_postalCode",
            "datatype": "String",
            "mappingkey": "addr_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true
        }
    ],
    "CAISNaturalPersonCols": [
        {
            "display": "false",
            "ui_columnname": "Id",
            "db_columnname": "id",
            "datatype": "char",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "rsmsStatus",
            "datatype": "char",
            "mappingkey": "rsmsStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 2
        },
        {
            "display": "false",
            "ui_columnname": "Firm",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 3
        },
        {
            "display": "false",
            "ui_columnname": "Active",
            "db_columnname": "active",
            "datatype": "String",
            "mappingkey": "active",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 4
        },
        {
            "display": "true",
            "ui_columnname": "File ID",
            "db_columnname": "fileID",
            "datatype": "String",
            "mappingkey": "fileID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 50
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 30
        },
        {
            "display": "false",
            "ui_columnname": "Report Reason",
            "db_columnname": "reportReason",
            "datatype": "String",
            "mappingkey": "reportReason",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "First Name",
            "db_columnname": "firstName",
            "datatype": "String",
            "mappingkey": "firstName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "200",
            "isrequired": false,
            "sortOrder": 5
        },
        {
            "display": "true",
            "ui_columnname": "Middle Name",
            "db_columnname": "middleName",
            "datatype": "String",
            "mappingkey": "middleName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "200",
            "sortOrder": 6
        },
        {
            "display": "true",
            "ui_columnname": "Last Name",
            "db_columnname": "lastName",
            "datatype": "String",
            "mappingkey": "lastName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 7
        },
        {
            "display": "true",
            "ui_columnname": "Name Suffix",
            "db_columnname": "nameSuffix",
            "datatype": "String",
            "mappingkey": "nameSuffix",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "JUNIOR",
                    "value": "JUNIOR"
                },
                {
                    "label": "SENIOR",
                    "value": "SENIOR"
                },
                {
                    "label": "THIRD",
                    "value": "THIRD"
                },
                {
                    "label": "FIFTH",
                    "value": "FIFTH"
                },
                {
                    "label": "FOURTH",
                    "value": "FOURTH"
                }
            ],
            "isOptionalFields": true,
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "Year Of Birth",
            "db_columnname": "yearOfBirth",
            "datatype": "String",
            "mappingkey": "yearOfBirth",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY",
            "maxlength": "4",
            "isrequired": false,
            "regexpressions": ["^[1-2][8|9|0][0-9][0-9]$"],
            "isOptionalFields": true,
            "sortOrder": 12
        },
        {
            "display": "true",
            "ui_columnname": "Doing Business As",
            "db_columnname": "doingBusinessAs",
            "datatype": "String",
            "mappingkey": "doingBusinessAs",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 13
        },
        {
            "display": "true",
            "ui_columnname": "Customer Type",
            "db_columnname": "customerType",
            "datatype": "Array",
            "mappingkey": "customerType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": [],
            "dropdowntype": "multiselect",
            "dropdownvalue": [
                {
                    "label": "ACCREDITED",
                    "value": "ACCREDITED"
                },
                {
                    "label": "ADVISER",
                    "value": "ADVISER"
                },
                {
                    "label": "CP",
                    "value": "CP"
                },
                {
                    "label": "EMPLOYEE",
                    "value": "EMPLOYEE"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "NOTAPPLICABLE",
                    "value": "NOTAPPLICABLE"
                },
                {
                    "label": "OTHBKR",
                    "value": "OTHBKR"
                },
                {
                    "label": "TRUST",
                    "value": "TRUST"
                },
                {
                    "label": "BD",
                    "value": "BD"
                },
                {
                    "label": "RIC",
                    "value": "RIC"
                }
            ],
            "isrequired": true,
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Role",
            "db_columnname": "role",
            "datatype": "String",
            "mappingkey": "role",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "AUTH3RD",
                    "value": "AUTH3RD"
                },
                {
                    "label": "AUTHREP",
                    "value": "AUTHREP"
                },
                {
                    "label": "NTHOLDER",
                    "value": "NTHOLDER"
                },
                {
                    "label": "TRDHOLDER",
                    "value": "TRDHOLDER"
                }
            ],
            "isrequired": true,
            "sortOrder": 15
        },
        {
            "display": "true",
            "ui_columnname": "Has Discretion",
            "db_columnname": "hasDiscretion",
            "datatype": "String",
            "mappingkey": "hasDiscretion",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "Y",
                    "value": "Y"
                },
                {
                    "label": "N",
                    "value": "N"
                }
            ],
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "Role Start Date",
            "db_columnname": "roleStartDate",
            "datatype": "Date",
            "mappingkey": "roleStartDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "isrequired": true,
            "sortOrder": 17
        },
        {
            "display": "true",
            "ui_columnname": "Role End Date",
            "db_columnname": "roleEndDate",
            "datatype": "Date",
            "mappingkey": "roleEndDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "sortOrder": 18
        },
        {
            "display": "true",
            "ui_columnname": "Role End Reason",
            "db_columnname": "roleEndReason",
            "datatype": "String",
            "mappingkey": "roleEndReason",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "CORRECTION",
                    "value": "CORRECTION"
                },
                {
                    "label": "ENDED",
                    "value": "ENDED"
                },
                {
                    "label": "REPLACED",
                    "value": "REPLACED"
                },
                {
                    "label": "OTHER",
                    "value": "OTHER"
                },
                {
                    "label": "TRANSFER",
                    "value": "TRANSFER"
                }
            ],
            "sortOrder": 19
        },
        {
            "display": "true",
            "ui_columnname": "TID Type",
            "db_columnname": "tidType",
            "datatype": "String",
            "mappingkey": "tidType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "isrequired": true,
            "sortOrder": 20
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Type",
            "db_columnname": "foreignTIDType",
            "datatype": "String",
            "mappingkey": "foreignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 21
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Country",
            "db_columnname": "foreignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "foreignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 22
        },
        {
            "display": "true",
            "ui_columnname": "Customer Record ID",
            "db_columnname": "customerRecordID",
            "datatype": "String",
            "mappingkey": "customerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 23
        },
        {
            "display": "true",
            "ui_columnname": "In Customer Record ID",
            "db_columnname": "inCustomerRecordID",
            "datatype": "String",
            "mappingkey": "inCustomerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 24
        },
        {
            "display": "true",
            "ui_columnname": "Rep By TID Type",
            "db_columnname": "replacedByTIDType",
            "datatype": "String",
            "mappingkey": "replacedByTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "sortOrder": 25
        },
        {
            "display": "true",
            "ui_columnname": "Rep by Foreign TID Type",
            "db_columnname": "replacingForeignTIDType",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 26
        },
        {
            "display": "true",
            "ui_columnname": "Replacing Foreign TID Country",
            "db_columnname": "replacingForeignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 27
        },
        {
            "display": "true",
            "ui_columnname": "Update Notification",
            "db_columnname": "updateNotification",
            "datatype": "String",
            "mappingkey": "updateNotification",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "Y",
                    "value": "Y"
                },
                {
                    "label": "N",
                    "value": "N"
                }
            ],
            "isOptionalFields": true,
            "sortOrder": 28
        },
        {
            "display": "true",
            "ui_columnname": "TID Value",
            "db_columnname": "tidValue",
            "datatype": "String",
            "mappingkey": "tidValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "64",
            "isLargeFields": true,
            "isrequired": true,
            "sortOrder": 28
        },
        {
            "display": "true",
            "ui_columnname": "Rep By TID Value",
            "db_columnname": "replacedByTID",
            "datatype": "String",
            "mappingkey": "replacedByTID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isLargeFields": true,
            "sortOrder": 29
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.1",
            "db_columnname": "addr1_addrLine1",
            "datatype": "String",
            "mappingkey": "addr1_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "isOptionalFields": true,
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.2",
            "db_columnname": "addr1_addrLine2",
            "datatype": "String",
            "mappingkey": "addr1_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 15
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.3",
            "db_columnname": "addr1_addrLine3",
            "datatype": "String",
            "mappingkey": "addr1_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.4",
            "db_columnname": "addr1_addrLine4",
            "datatype": "String",
            "mappingkey": "addr1_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 17
        },
        {
            "display": "true",
            "ui_columnname": "City 1",
            "db_columnname": "addr1_city",
            "datatype": "String",
            "mappingkey": "addr1_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "isOptionalFields": true,
            "sortOrder": 18
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 1",
            "db_columnname": "addr1_regionCode",
            "datatype": "String",
            "mappingkey": "addr1_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 19
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 1",
            "db_columnname": "addr1_countryCode",
            "datatype": "String",
            "mappingkey": "addr1_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "isOptionalFields": true,
            "sortOrder": 20
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 1",
            "db_columnname": "addr1_postalCode",
            "datatype": "String",
            "mappingkey": "addr1_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 21
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2",
            "db_columnname": "addr2_addrLine2",
            "datatype": "String",
            "mappingkey": "addr2_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 22
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.2",
            "db_columnname": "addr2_addrLine2",
            "datatype": "String",
            "mappingkey": "addr2_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 23
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.3",
            "db_columnname": "addr2_addrLine3",
            "datatype": "String",
            "mappingkey": "addr2_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 24
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.4",
            "db_columnname": "addr2_addrLine4",
            "datatype": "String",
            "mappingkey": "addr2_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 25
        },
        {
            "display": "true",
            "ui_columnname": "City 2",
            "db_columnname": "addr2_city",
            "datatype": "String",
            "mappingkey": "addr2_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 26
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 2",
            "db_columnname": "addr2_regionCode",
            "datatype": "String",
            "mappingkey": "addr2_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 27
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 2",
            "db_columnname": "addr2_countryCode",
            "datatype": "String",
            "mappingkey": "addr2_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 28
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 2",
            "db_columnname": "addr2_postalCode",
            "datatype": "String",
            "mappingkey": "addr2_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 29
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3",
            "db_columnname": "addr3_addrLine1",
            "datatype": "String",
            "mappingkey": "addr3_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 30
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.2",
            "db_columnname": "addr3_addrLine2",
            "datatype": "String",
            "mappingkey": "addr3_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 31
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.3",
            "db_columnname": "addr3_addrLine3",
            "datatype": "String",
            "mappingkey": "addr3_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 32
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.4",
            "db_columnname": "addr3_addrLine4",
            "datatype": "String",
            "mappingkey": "addr3_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 33
        },
        {
            "display": "true",
            "ui_columnname": "City 3",
            "db_columnname": "addr3_city",
            "datatype": "String",
            "mappingkey": "addr3_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 34
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 3",
            "db_columnname": "addr3_regionCode",
            "datatype": "String",
            "mappingkey": "addr3_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 35
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 3",
            "db_columnname": "addr3_countryCode",
            "datatype": "String",
            "mappingkey": "addr3_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 36
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 3",
            "db_columnname": "addr3_postalCode",
            "datatype": "String",
            "mappingkey": "addr3_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 37
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4",
            "db_columnname": "addr4_addrLine1",
            "datatype": "String",
            "mappingkey": "addr4_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 38
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.2",
            "db_columnname": "addr4_addrLine2",
            "datatype": "String",
            "mappingkey": "addr4_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 39
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.3",
            "db_columnname": "addr4_addrLine3",
            "datatype": "String",
            "mappingkey": "addr4_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.4",
            "db_columnname": "addr4_addrLine4",
            "datatype": "String",
            "mappingkey": "addr4_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 41
        },
        {
            "display": "true",
            "ui_columnname": "City 4",
            "db_columnname": "addr4_city",
            "datatype": "String",
            "mappingkey": "addr4_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 42
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 4",
            "db_columnname": "addr4_regionCode",
            "datatype": "String",
            "mappingkey": "addr4_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 43
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 4",
            "db_columnname": "addr4_countryCode",
            "datatype": "String",
            "mappingkey": "addr4_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 44
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 4",
            "db_columnname": "addr4_postalCode",
            "datatype": "String",
            "mappingkey": "addr4_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 45
        }
    ],
    "CAISLegalEntityCols": [
        {
            "display": "false",
            "ui_columnname": "Id",
            "db_columnname": "id",
            "datatype": "char",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "false",
            "ui_columnname": "Action",
            "db_columnname": "rsmsStatus",
            "datatype": "char",
            "mappingkey": "rsmsStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 2
        },
        {
            "display": "false",
            "ui_columnname": "Firm",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 3
        },
        {
            "display": "false",
            "ui_columnname": "Active",
            "db_columnname": "active",
            "datatype": "String",
            "mappingkey": "active",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 4
        },
        {
            "display": "false",
            "ui_columnname": "File ID",
            "db_columnname": "fileID",
            "datatype": "String",
            "mappingkey": "fileID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 44
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 24
        },
        {
            "display": "false",
            "ui_columnname": "Report Reason",
            "db_columnname": "reportReason",
            "datatype": "String",
            "mappingkey": "reportReason",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "Legal Name",
            "db_columnname": "legalName",
            "datatype": "String",
            "mappingkey": "legalName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 5
        },
        {
            "display": "true",
            "ui_columnname": "EIN",
            "db_columnname": "ein",
            "datatype": "String",
            "mappingkey": "ein",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "99-9999999",
            "regexpressions": ["^(\\d{2})([-])(\\d{7})$"],
            "isOptionalFields": true,
            "sortOrder": 6
        },
        {
            "display": "true",
            "ui_columnname": "LEI",
            "db_columnname": "lei",
            "datatype": "String",
            "mappingkey": "lei",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 7
        },
        {
            "display": "true",
            "ui_columnname": "Customer Type",
            "db_columnname": "customerType",
            "datatype": "Array",
            "mappingkey": "customerType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": [],
            "dropdowntype": "multiselect",
            "dropdownvalue": [
                {
                    "label": "ACCREDITED",
                    "value": "ACCREDITED"
                },
                {
                    "label": "ADVISER",
                    "value": "ADVISER"
                },
                {
                    "label": "CP",
                    "value": "CP"
                },
                {
                    "label": "EMPLOYEE",
                    "value": "EMPLOYEE"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "NOTAPPLICABLE",
                    "value": "NOTAPPLICABLE"
                },
                {
                    "label": "OTHBKR",
                    "value": "OTHBKR"
                },
                {
                    "label": "TRUST",
                    "value": "TRUST"
                },
                {
                    "label": "BD",
                    "value": "BD"
                },
                {
                    "label": "RIC",
                    "value": "RIC"
                }
            ],
            "isrequired": true,
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "Role",
            "db_columnname": "role",
            "datatype": "String",
            "mappingkey": "role",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "AUTH3RD",
                    "value": "AUTH3RD"
                },
                {
                    "label": "AUTHREP",
                    "value": "AUTHREP"
                },
                {
                    "label": "NTHOLDER",
                    "value": "NTHOLDER"
                },
                {
                    "label": "TRDHOLDER",
                    "value": "TRDHOLDER"
                }
            ],
            "isrequired": true,
            "sortOrder": 9
        },
        {
            "display": "true",
            "ui_columnname": "Has Discretion",
            "db_columnname": "hasDiscretion",
            "datatype": "String",
            "mappingkey": "hasDiscretion",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "Y",
                    "value": "Y"
                },
                {
                    "label": "N",
                    "value": "N"
                }
            ],
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "Role Start Date",
            "db_columnname": "roleStartDate",
            "datatype": "Date",
            "mappingkey": "roleStartDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "isrequired": true,
            "sortOrder": 11
        },
        {
            "display": "true",
            "ui_columnname": "Role End Date",
            "db_columnname": "roleEndDate",
            "datatype": "Date",
            "mappingkey": "roleEndDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "sortOrder": 12
        },
        {
            "display": "true",
            "ui_columnname": "Role End Reason",
            "db_columnname": "roleEndReason",
            "datatype": "String",
            "mappingkey": "roleEndReason",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "CORRECTION",
                    "value": "CORRECTION"
                },
                {
                    "label": "ENDED",
                    "value": "ENDED"
                },
                {
                    "label": "REPLACED",
                    "value": "REPLACED"
                },
                {
                    "label": "OTHER",
                    "value": "OTHER"
                },
                {
                    "label": "TRANSFER",
                    "value": "TRANSFER"
                }
            ],
            "sortOrder": 13
        },
        {
            "display": "true",
            "ui_columnname": "TID Type",
            "db_columnname": "tidType",
            "datatype": "String",
            "mappingkey": "tidType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "isrequired": true,
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Type",
            "db_columnname": "foreignTIDType",
            "datatype": "String",
            "mappingkey": "foreignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 15
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Country",
            "db_columnname": "foreignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "foreignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "Customer Record ID",
            "db_columnname": "customerRecordID",
            "datatype": "String",
            "mappingkey": "customerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 17
        },
        {
            "display": "true",
            "ui_columnname": "In Customer Record ID",
            "db_columnname": "inCustomerRecordID",
            "datatype": "String",
            "mappingkey": "inCustomerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 18
        },
        {
            "display": "true",
            "ui_columnname": "Rep By TID Type",
            "db_columnname": "replacedByTIDType",
            "datatype": "String",
            "mappingkey": "replacedByTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "sortOrder": 19
        },
        {
            "display": "true",
            "ui_columnname": "Rep by Foreign TID Type",
            "db_columnname": "replacingForeignTIDType",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 20
        },
        {
            "display": "true",
            "ui_columnname": "Replacing Foreign TID Country",
            "db_columnname": "replacingForeignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 21
        },
        {
            "display": "true",
            "ui_columnname": "Update Notification",
            "db_columnname": "updateNotification",
            "datatype": "String",
            "mappingkey": "updateNotification",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "Y",
                    "value": "Y"
                },
                {
                    "label": "N",
                    "value": "N"
                }
            ],
            "isOptionalFields": true,
            "sortOrder": 22
        },
        {
            "display": "true",
            "ui_columnname": "TID Value",
            "db_columnname": "tidValue",
            "datatype": "String",
            "mappingkey": "tidValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "64",
            "isLargeFields": true,
            "isrequired": true,
            "sortOrder": 22
        },
        
        {
            "display": "true",
            "ui_columnname": "Rep By TID Value",
            "db_columnname": "replacedByTID",
            "datatype": "String",
            "mappingkey": "replacedByTID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isLargeFields": true,
            "sortOrder": 23
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.1",
            "db_columnname": "addr1_addrLine1",
            "datatype": "String",
            "mappingkey": "addr1_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "isOptionalFields": true,
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.2",
            "db_columnname": "addr1_addrLine2",
            "datatype": "String",
            "mappingkey": "addr1_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 9
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.3",
            "db_columnname": "addr1_addrLine3",
            "datatype": "String",
            "mappingkey": "addr1_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.4",
            "db_columnname": "addr1_addrLine4",
            "datatype": "String",
            "mappingkey": "addr1_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 11
        },
        {
            "display": "true",
            "ui_columnname": "City 1",
            "db_columnname": "addr1_city",
            "datatype": "String",
            "mappingkey": "addr1_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "isOptionalFields": true,
            "sortOrder": 12
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 1",
            "db_columnname": "addr1_regionCode",
            "datatype": "String",
            "mappingkey": "addr1_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 13
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 1",
            "db_columnname": "addr1_countryCode",
            "datatype": "String",
            "mappingkey": "addr1_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "isOptionalFields": true,
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 1",
            "db_columnname": "addr1_postalCode",
            "datatype": "String",
            "mappingkey": "addr1_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 15
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2",
            "db_columnname": "addr2_addrLine2",
            "datatype": "String",
            "mappingkey": "addr2_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.2",
            "db_columnname": "addr2_addrLine2",
            "datatype": "String",
            "mappingkey": "addr2_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 17
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.3",
            "db_columnname": "addr2_addrLine3",
            "datatype": "String",
            "mappingkey": "addr2_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 18
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.4",
            "db_columnname": "addr2_addrLine4",
            "datatype": "String",
            "mappingkey": "addr2_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 19
        },
        {
            "display": "true",
            "ui_columnname": "City 2",
            "db_columnname": "addr2_city",
            "datatype": "String",
            "mappingkey": "addr2_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 20
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 2",
            "db_columnname": "addr2_regionCode",
            "datatype": "String",
            "mappingkey": "addr2_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 21
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 2",
            "db_columnname": "addr2_countryCode",
            "datatype": "String",
            "mappingkey": "addr2_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 22
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 2",
            "db_columnname": "addr2_postalCode",
            "datatype": "String",
            "mappingkey": "addr2_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 23
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3",
            "db_columnname": "addr3_addrLine1",
            "datatype": "String",
            "mappingkey": "addr3_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 24
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.2",
            "db_columnname": "addr3_addrLine2",
            "datatype": "String",
            "mappingkey": "addr3_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 25
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.3",
            "db_columnname": "addr3_addrLine3",
            "datatype": "String",
            "mappingkey": "addr3_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 26
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.4",
            "db_columnname": "addr3_addrLine4",
            "datatype": "String",
            "mappingkey": "addr3_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 27
        },
        {
            "display": "true",
            "ui_columnname": "City 3",
            "db_columnname": "addr3_city",
            "datatype": "String",
            "mappingkey": "addr3_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 28
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 3",
            "db_columnname": "addr3_regionCode",
            "datatype": "String",
            "mappingkey": "addr3_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 29
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 3",
            "db_columnname": "addr3_countryCode",
            "datatype": "String",
            "mappingkey": "addr3_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 30
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 3",
            "db_columnname": "addr3_postalCode",
            "datatype": "String",
            "mappingkey": "addr3_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 31
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4",
            "db_columnname": "addr4_addrLine1",
            "datatype": "String",
            "mappingkey": "addr4_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 32
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.2",
            "db_columnname": "addr4_addrLine2",
            "datatype": "String",
            "mappingkey": "addr4_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 33
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.3",
            "db_columnname": "addr4_addrLine3",
            "datatype": "String",
            "mappingkey": "addr4_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 34
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.4",
            "db_columnname": "addr4_addrLine4",
            "datatype": "String",
            "mappingkey": "addr4_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 35
        },
        {
            "display": "true",
            "ui_columnname": "City 4",
            "db_columnname": "addr4_city",
            "datatype": "String",
            "mappingkey": "addr4_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 36
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 4",
            "db_columnname": "addr4_regionCode",
            "datatype": "String",
            "mappingkey": "addr4_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 37
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 4",
            "db_columnname": "addr4_countryCode",
            "datatype": "String",
            "mappingkey": "addr4_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isOptionalFields": true,
            "sortOrder": 38
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 4",
            "db_columnname": "addr4_postalCode",
            "datatype": "String",
            "mappingkey": "addr4_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "isOptionalFields": true,
            "sortOrder": 39
        }
    ],
    "CAISLTIDCols": [
        {
            "display": "false",
            "ui_columnname": "ID",
            "db_columnname": "id",
            "datatype": "String",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "true",
            "ui_columnname": "Large TraderID",
            "db_columnname": "largeTraderID",
            "datatype": "String",
            "mappingkey": "largeTraderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "LTID – 00000000-0000 | ULTID – ULTXXXXX-XXXX",
            "maxlength": "13",
            "isrequired": false,
            "regexpressions": ["^(\\d{8})([-])(\\d{4})$", "^(ULT)(\\d{5})([-])(\\d{4})$"],
            "isOptionalFields": true,
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "LTID Effective Date",
            "db_columnname": "ltidEffectiveDate",
            "datatype": "Date",
            "mappingkey": "ltidEffectiveDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "isrequired": false,
            "isOptionalFields": true,
            "sortOrder": 3
        },
        {
            "display": "true",
            "ui_columnname": "LTID End Date",
            "db_columnname": "ltidEndDate",
            "datatype": "Date",
            "mappingkey": "ltidEndDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY-MM-DD",
            "isOptionalFields": true,
            "sortOrder": 4
        },
        {
            "display": "true",
            "ui_columnname": "LTID End Reason",
            "db_columnname": "ltidEndReason",
            "datatype": "String",
            "mappingkey": "ltidEndReason",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "CORRECTION",
                    "value": "CORRECTION"
                },
                {
                    "label": "ENDED",
                    "value": "ENDED"
                },
                {
                    "label": "REPLACED",
                    "value": "REPLACED"
                },
                {
                    "label": "OTHER",
                    "value": "OTHER"
                },
                {
                    "label": "TRANSFER",
                    "value": "TRANSFER"
                }
            ],
            "isOptionalFields": true,
            "sortOrder": 5
        }
    ],
    "CAISTIDCols": [
        {
            "display": "false",
            "ui_columnname": "Id",
            "db_columnname": "id",
            "datatype": "String",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "true",
            "ui_columnname": "TID Type",
            "db_columnname": "tidType",
            "datatype": "String",
            "mappingkey": "tidType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "isrequired": true,
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Type",
            "db_columnname": "foreignTIDType",
            "datatype": "String",
            "mappingkey": "foreignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 3
        },
        {
            "display": "true",
            "ui_columnname": "TID Value",
            "db_columnname": "tidValue",
            "datatype": "String",
            "mappingkey": "tidValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": true,
            "sortOrder": 4
        },
        {
            "display": "true",
            "ui_columnname": "Rep By TID Type",
            "db_columnname": "replacedByTIDType",
            "datatype": "String",
            "mappingkey": "replacedByTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "sortOrder": 5
        },
        {
            "display": "true",
            "ui_columnname": "Rep by Foreign TID Type",
            "db_columnname": "replacingForeignTIDType",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 6
        },
        {
            "display": "true",
            "ui_columnname": "Rep By TID Value",
            "db_columnname": "replacedByTID",
            "datatype": "String",
            "mappingkey": "replacedByTID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 7
        }
    ]
}